import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "body"]
  static values = { 
    currentSort: { type: String, default: "title" },
    currentDirection: { type: String, default: "asc" }
  }

  connect() {
    // Sort by title (alphabetically) on page load
    this.sortBy("title", "asc")
  }

  sort(event) {
    const column = event.currentTarget.dataset.column
    const direction = this.currentSortValue === column && this.currentDirectionValue === "asc" ? "desc" : "asc"
    
    this.sortBy(column, direction)
  }

  sortBy(column, direction) {
    this.currentSortValue = column
    this.currentDirectionValue = direction

    const tbody = this.bodyTarget
    const rows = Array.from(tbody.querySelectorAll('tr'))
    
    // Update header indicators
    this.updateHeaderIndicators(column, direction)
    
    // Sort rows
    rows.sort((a, b) => {
      const aValue = this.getCellValue(a, column)
      const bValue = this.getCellValue(b, column)
      
      let comparison = 0
      if (aValue < bValue) comparison = -1
      if (aValue > bValue) comparison = 1
      
      return direction === "desc" ? -comparison : comparison
    })
    
    // Re-append sorted rows
    rows.forEach(row => tbody.appendChild(row))
  }

  getCellValue(row, column) {
    const cellIndex = this.getColumnIndex(column)
    if (cellIndex === -1) return ""
    
    const cell = row.cells[cellIndex]
    if (!cell) return ""
    
    // Handle different column types
    switch (column) {
      case "title":
        // Extract text from the strong tag or the entire cell
        const titleElement = cell.querySelector('strong')
        return titleElement ? titleElement.textContent.trim().toLowerCase() : cell.textContent.trim().toLowerCase()
      
      case "description":
        // Get the text content, excluding the edit icon
        const descElement = cell.querySelector('[data-inline-edit-target="display"]')
        if (descElement) {
          return descElement.textContent.replace(/.*fa-edit.*/, '').trim().toLowerCase()
        }
        return cell.textContent.trim().toLowerCase()
      
      case "policy":
        return cell.textContent.trim().toLowerCase()
      
      case "references":
        // Extract number from badge
        const badge = cell.querySelector('.badge')
        return badge ? parseInt(badge.textContent) || 0 : 0
      
      default:
        return cell.textContent.trim().toLowerCase()
    }
  }

  getColumnIndex(column) {
    const headers = this.headerTargets
    for (let i = 0; i < headers.length; i++) {
      if (headers[i].dataset.column === column) {
        return i
      }
    }
    return -1
  }

  updateHeaderIndicators(activeColumn, direction) {
    this.headerTargets.forEach(header => {
      const column = header.dataset.column
      const iconContainer = header.querySelector('.sort-icon')
      
      if (iconContainer) {
        // Remove existing icon
        const existingIcon = iconContainer.querySelector('i, svg')
        if (existingIcon) {
          existingIcon.remove()
        }
        
        // Create new icon
        const newIcon = document.createElement('i')
        if (column === activeColumn) {
          newIcon.className = `fas ${direction === 'asc' ? 'fa-sort-up' : 'fa-sort-down'}`
        } else {
          newIcon.className = 'fas fa-sort text-muted'
        }
        
        iconContainer.appendChild(newIcon)
      }
    })
  }
}